import React, { FunctionComponent, useState } from 'react'
import { ActionBar, Button, Dott, Text } from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import { UpdateSaleCustomerModal } from '../../../modals/update-customer-modal'

const AddEmailButton: FunctionComponent = () => {
  const [openModal, setOpenModal] = useState(false)

  return (
    <>
      <Button
        onClick={() => {
          setOpenModal(true)
        }}
        link
      >
        <T
          _str="Add an email address"
          _context="Selected customer does not have an email address"
        />
      </Button>
      {openModal ? (
        <UpdateSaleCustomerModal onClose={() => setOpenModal(false)} />
      ) : null}
    </>
  )
}

export const AddEmailToCustomer: FunctionComponent = () => {
  return (
    <ActionBar className="vd-pl5 vd-pr5">
      <div>
        <Dott />
      </div>
      <Text tag="div" className="vd-align-left vd-ml3">
        <T
          _str="{addEmailButton} to this customer so that you can email them receipts or promotional emails."
          _context="Button opens the customer edit to add an email address"
          addEmailButton={<AddEmailButton />}
        />
      </Text>
    </ActionBar>
  )
}
